var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm8: "", "offset-sm2": "" } },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { color: "indigo", dark: "" } },
                [_c("v-toolbar-title", [_vm._v("Integraciones")])],
                1
              ),
              _c(
                "v-list",
                { attrs: { "two-line": "", subheader: "" } },
                _vm._l(_vm.IntegrationList, function(item) {
                  return _c(
                    "v-list-tile",
                    { key: item.key, attrs: { avatar: "" } },
                    [
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v("Integrador: " + _vm._s(item.integrador))
                          ]),
                          _c("v-list-tile-sub-title", [
                            _vm._v(_vm._s(item.nombre_ws))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              ),
              _c("v-list", { attrs: { subheader: "", "two-line": "" } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }